import refreshIcon from '@raison/static/icons/refresh-line.svg';
import React from 'react';
import {cn, RootLayout, Skeleton, SkeletonContextProvider} from '~/library/ui-kit';

export function SkeletonPageLayout({
    title,
    stopped,
    reset,
    children,
}: React.PropsWithChildren<{
    title?: string;
    stopped?: boolean;
    reset?: () => void;
}>) {
    return (
        <SkeletonContextProvider value={{stopped}}>
            <RootLayout
                common
                title={title}
                pageHeader={
                    title ? undefined : (
                        <RootLayout.BaseHeader>
                            <RootLayout.MenuButton />
                            <Skeleton width={96} />
                            <RootLayout.BackButton />
                        </RootLayout.BaseHeader>
                    )
                }
            >
                {children}
                {stopped && <LoadProblemPane reset={reset} />}
            </RootLayout>
        </SkeletonContextProvider>
    );
}

export function LoadProblemPane({
    reset,
    t,
}: {
    reset: undefined | (() => void);
    t?: {
        Problem?: string;
        SuggestRefresh?: string;
        SuggestReopen?: string;
    };
}) {
    let Tag: 'div' | 'button' = 'div';
    if (reset) {
        Tag = 'button';
    }
    t = {
        Problem: "We couldn't load this page.",
        SuggestRefresh: ' Tap to refresh',
        SuggestReopen: ' Try reopening it.',
        ...t,
    };

    return (
        <Tag
            onClick={reset}
            className={cn(
                'shadow-md fv-text-m absolute bottom-14 left-8 right-8 z-10 flex items-center',
                'rounded-md border border-solid border-warning-30 bg-[#F9D9BC] p-3 shadow-[rgba(101,53,8,0.20)]',
                'fv-text-m-regular text-neutral-100'
            )}
        >
            {t.Problem}
            {reset ? t.SuggestRefresh : t.SuggestReopen}
            {reset && <img className='ml-auto size-6' src={refreshIcon} alt='' />}
        </Tag>
    );
}
